import * as i0 from '@angular/core';
import { forwardRef, Input, Directive } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import AutoNumeric from 'autonumeric';
class AutonumericDirective {
  set _emptyInputBehavior(value) {
    if (value) {
      this.emptyInputBehavior = value;
      this.updateNumericSettings();
    }
  }
  set _max(value) {
    if (value) {
      this.max = value;
      this.updateNumericSettings();
    }
  }
  set _min(value) {
    if (value) {
      this.min = value;
      this.updateNumericSettings();
    }
  }
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.percentage = false;
    this.decimalPlaces = 4;
    this.modifyValueOnWheel = true;
    this.disabled = false;
    //https://docs.autonumeric.org/Documentation/configuration%20options/
    this.emptyInputBehavior = 'focus';
    this.max = '999999999999999.9999';
    this.min = '-999999999999999.9999';
    //ControlValueAccessor implementations
    this.propagateChange = _ => {};
    this.preventNegative = false;
    const Options = {
      digitGroupSeparator: ',',
      //separator of number
      decimalCharacter: '.',
      //semicolon separator replaced with point 
      decimalPlaces: this.decimalPlaces,
      // total of decimal after separator 
      maximumValue: this.max,
      // maximum of number
      minimumValue: this.min,
      // minum of of number
      allowDecimalPadding: false,
      showWarnings: false
    };
    this.numericElement = new AutoNumeric(this.elementRef.nativeElement, null, Options);
  }
  ngOnInit() {
    if (this.percentage) {
      this.max = '100';
    }
    if (this.preventNegative) {
      this.min = '0.00';
    }
    this.updateNumericSettings();
  }
  updateNumericSettings() {
    const OptionsUpdate = {
      maximumValue: this.max,
      // maximum of number
      minimumValue: this.min,
      // minimum of number,
      readOnly: this.isElementDisabled(),
      decimalPlaces: this.decimalPlaces,
      // total of decimal after separator 
      modifyValueOnWheel: this.modifyValueOnWheel,
      emptyInputBehavior: this.emptyInputBehavior
    };
    this.numericElement.update(OptionsUpdate);
  }
  onKeyUp() {
    let number = this.numericElement.getNumber();
    this.propagateChange(number);
  }
  onPaste() {
    let number = this.numericElement.getNumber();
    this.propagateChange(number);
  }
  isElementDisabled() {
    let retVal = false;
    const readonly = this.elementRef.nativeElement.readOnly;
    // disabled element when @input() disabled set to true
    this.elementRef.nativeElement.disabled = this.disabled;
    //check whether element set to readOnly
    if (readonly === true && !this.disabled) {
      retVal = true;
    }
    return retVal;
  }
  writeValue(newValue) {
    if (newValue != null) {
      this.numericElement.set(newValue);
    }
  }
  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched() {}
  static {
    this.ɵfac = function AutonumericDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AutonumericDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AutonumericDirective,
      selectors: [["", "autoNum", ""]],
      hostBindings: function AutonumericDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keyup", function AutonumericDirective_keyup_HostBindingHandler() {
            return ctx.onKeyUp();
          });
        }
      },
      inputs: {
        percentage: "percentage",
        preventNegative: "preventNegative",
        decimalPlaces: "decimalPlaces",
        modifyValueOnWheel: "modifyValueOnWheel",
        disabled: "disabled",
        _emptyInputBehavior: [0, "emptyInputBehavior", "_emptyInputBehavior"],
        _max: [0, "max", "_max"],
        _min: [0, "min", "_min"]
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => AutonumericDirective),
        multi: true
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutonumericDirective, [{
    type: Directive,
    args: [{
      selector: '[autoNum]',
      standalone: true,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => AutonumericDirective),
        multi: true
      }],
      host: {
        "(keyup)": "onKeyUp()"
      }
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    percentage: [{
      type: Input
    }],
    preventNegative: [{
      type: Input
    }],
    decimalPlaces: [{
      type: Input
    }],
    modifyValueOnWheel: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    _emptyInputBehavior: [{
      type: Input,
      args: ["emptyInputBehavior"]
    }],
    _max: [{
      type: Input,
      args: ['max']
    }],
    _min: [{
      type: Input,
      args: ['min']
    }]
  });
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AutonumericDirective };
